import { Money } from '@/components/ui/Money';
import {
  COMMON_COLUMNS,
  MONEY_NUM_FMT,
  type DrilldownColumn,
} from '../drilldown-columns-shared';

/**
 * Collected tile drill-down columns (owner 2026-10-28).
 *
 * One row per invoice with cash. `row.date` is the metric's WINDOW date for
 * Collected, i.e. the paid-on date (fully-paid date, else bill date) — so the
 * date column is labelled "Paid on", not "Date".
 *
 * Two money figures in document currency:
 * - `paidAmount` — what Xero says was paid, INCL. VAT (reference only);
 * - `amount` — the cash EX-VAT the tile measures.
 * `convertedAmount` is `amount` in `meta.measuredInCurrency`; only it
 * reconciles to the tile. Neither is re-derived here.
 */

const subject: DrilldownColumn = { ...COMMON_COLUMNS.title, label: 'Subject' };

const paidOn: DrilldownColumn = { ...COMMON_COLUMNS.date, label: 'Paid on' };

const paidInclVat: DrilldownColumn = {
  key: 'paidAmount',
  label: 'Paid incl. VAT',
  get: (row) => row.paidAmount ?? null,
  render: (row) => <Money amount={row.paidAmount} currency={row.currency} />,
  numeric: true,
  numFmt: MONEY_NUM_FMT,
  filter: 'range',
};

const cashExVat: DrilldownColumn = { ...COMMON_COLUMNS.amount, label: 'Cash ex-VAT' };

export const COLLECTED_COLUMNS: DrilldownColumn[] = [
  COMMON_COLUMNS.number,
  subject,
  COMMON_COLUMNS.company,
  COMMON_COLUMNS.projects,
  COMMON_COLUMNS.accountLead,
  paidOn,
  COMMON_COLUMNS.status,
  COMMON_COLUMNS.billingRegion,
  COMMON_COLUMNS.currency,
  paidInclVat,
  cashExVat,
  COMMON_COLUMNS.convertedAmount,
];
